import { useMemo } from 'react';
import { usePromptPageContext } from 'src/components/Prompt/context/PromptPageContext';

type TData = {
  next: VoidFunction;
  prev: VoidFunction;
  prevId: string | undefined;
  nextId: string | undefined;
  hasMore: boolean;
};

export const usePromptReplyPreviewNavigation = () => {
  const { preview, prompt: promptQuery } = usePromptPageContext();
  const prompt = promptQuery?.data?.article;
  const promptReplies = prompt?.childArticles || [];
  const currentIndex = promptReplies.findIndex((reply) => reply.id === preview.state.articleId);
  const nextReply = promptReplies[currentIndex + 1];
  const prevReply = promptReplies[currentIndex - 1];
  const repliesCount = prompt?.childArticlesCount || 0;

  const prevId = prevReply?.id;
  const nextId = nextReply?.id;

  const hasMore = repliesCount > promptReplies.length;

  const next = async () => {
    let id: string | undefined = nextId;
    if (!id && hasMore) {
      const more = await promptQuery?.fetchMore({ variables: { skip: promptReplies.length } });
      id = more?.data?.article?.childArticles?.[0]?.id;
    }

    preview.setState({ articleId: id || null });
  };

  const prev = () => {
    preview.setState({ articleId: prevId || null });
  };

  const data: TData = useMemo(
    () => ({
      next,
      prev,
      hasMore,
      nextId,
      prevId,
    }),
    [next, prev, hasMore, nextId, prevId, hasMore],
  );

  return data;
};
